<template>
<div>

    <b-row>
        <b-col md="8" lg="8">
            <div class="d-flex">
                <feather-icon icon="UserIcon" size="19" />
                <h4 class="mb-0 ml-50">
                    {{ $t('Account Information') }}
                </h4>
            </div>
            <!-- Form: Personal Info Form -->
            <b-form class="mt-1">
                <b-row>
                    <b-col cols="12" md="12" lg="12">
                        <b-form-group :label="$t('Company / Client Logo (400px x 132px)')" label-for="member_code">
                            <b-form-file
                                id="extension"
                                accept=".jpg,.png"
                                v-model="data.account.new_logo"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="12" lg="6">
                        <b-form-group :label="$t('Invoice Language')" label-for="member_code">
                            <b-form-input id="member_code" v-model="data.account.invoice_language" disabled/>
                        </b-form-group>
                    </b-col>
                    <b-col md="12" lg="6">
                        <b-form-group :label="$t('Invoice Type')" label-for="member_code">
                            <v-select :options="invoiceTypeOptions" :clearable="false" v-model="data.account.invoice_type" :reduce="item => item.value"  />
                        </b-form-group>
                    </b-col>
                    <b-col cmd="12" lg="6">
                        <b-form-group :label="$t('Auto Send Invoice')" label-for="member_code">
                            <div>
                                <b-form-checkbox
                                    :checked="to_true_false(data.account.auto_send_pdf)"
                                    class="custom-control-success"
                                    v-model="data.account.auto_send_pdf"
                                    name="check-button"
                                    switch
                                >
                                    <span class="switch-icon-left">
                                    <feather-icon icon="CheckIcon" />
                                    </span>
                                    <span class="switch-icon-right">
                                    <feather-icon icon="XIcon" />
                                    </span>
                                </b-form-checkbox>
                                </div>
                        </b-form-group>
                    </b-col>
                    <b-col  md="12" lg="6">
                        <b-form-group :label="$t('Package Signature Required')" label-for="member_code">
                            <div>
                                <b-form-checkbox
                                    :checked="to_true_false(data.account.member_package_need_sign)"
                                    class="custom-control-success"
                                    name="check-button"
                                    v-model="data.account.member_package_need_sign"
                                    switch
                                >
                                    <span class="switch-icon-left">
                                    <feather-icon icon="CheckIcon" />
                                    </span>
                                    <span class="switch-icon-right">
                                    <feather-icon icon="XIcon" />
                                    </span>
                                </b-form-checkbox>
                                </div>
                        </b-form-group>
                    </b-col>
                    <b-col md="12" lg="6">
                        <b-form-group :label="$t('PT Session Lock Time (minutes)')" label-for="member_code">
                            <b-form-input id="member_code" v-model="data.account.pt_lock_time" />
                        </b-form-group>
                    </b-col>
                    <b-col md="12" lg="6">
                        <b-form-group :label="$t('Class Session Lock Time (minutes)')" label-for="member_code">
                            <b-form-input id="member_code" v-model="data.account.class_lock_time"  />
                        </b-form-group>
                    </b-col>
                    <b-col md="12" lg="6">
                        <b-form-group :label="$t('Schedule Time Step (minutes)')" label-for="member_code">
                            <b-form-input id="member_code" v-model="data.account.calendar_minute_step"  />
                        </b-form-group>
                    </b-col>
                    <b-col md="6" lg="6">
                        <b-form-group :label="$t('Schedule First Day')" label-for="member_code">
                            <v-select :options="scheduleFirstDayOptions"
                                v-model="data.account.calendar_first_day"
                                :reduce="day => day.value"
                                :clearable="false"
                                />
                        </b-form-group>
                    </b-col>
                    <b-col cols="6" md="6" lg="6">
                        <b-form-group :label="$t('Schedule Display Member Field')" label-for="member_code">
                            <v-select :options="scheduleDisplayFieldOptions"
                                v-model="data.account.calendar_display_field"
                                :reduce="day => day.value"
                                :clearable="false"
                                />
                        </b-form-group>
                    </b-col>
                    <b-col md="12" lg="6">
                        <b-form-group :label="$t('App Display Class Day')" label-for="member_code">
                            <b-form-input id="member_code" v-model="data.account.app_display_day" disabled />
                        </b-form-group>
                    </b-col>
                    <b-col  md="12" lg="6">
                        <b-form-group :label="$t('App Delete Class Booking Limit')" label-for="member_code">
                            <b-form-input id="member_code" v-model="data.account.delete_class_limit" disabled />
                        </b-form-group>
                    </b-col>
                    <b-col md="12" lg="6">
                        <b-form-group :label="$t('Class Auto Attend')" label-for="member_code">
                            <div>
                                <b-form-checkbox
                                    :checked="to_true_false(data.account.class_auto_attend)"
                                    class="custom-control-success"
                                    name="check-button"
                                    v-model="data.account.class_auto_attend"
                                    switch
                                >
                                    <span class="switch-icon-left">
                                    <feather-icon icon="CheckIcon" />
                                    </span>
                                    <span class="switch-icon-right">
                                    <feather-icon icon="XIcon" />
                                    </span>
                                </b-form-checkbox>
                                </div>
                        </b-form-group>
                    </b-col>
                    <b-col md="12" lg="6">
                        <b-form-group :label="$t('Dues Invoice Auto Send')" label-for="member_code">
                            <div>
                                <b-form-checkbox
                                    :checked="to_true_false(data.account.crontab_send_invoice)"
                                    class="custom-control-success"
                                    name="check-button"
                                    v-model="data.account.crontab_send_invoice"
                                    switch
                                >
                                    <span class="switch-icon-left">
                                    <feather-icon icon="CheckIcon" />
                                    </span>
                                    <span class="switch-icon-right">
                                    <feather-icon icon="XIcon" />
                                    </span>
                                </b-form-checkbox>
                            </div>
                        </b-form-group>
                    </b-col>
                    <b-col md="12" lg="6">
                        <b-form-group :label="$t('PT Session Attend Message')" label-for="member_code">
                            <div>
                                <b-form-checkbox
                                    :checked="to_true_false(data.account.pt_attend_whatsapp)"
                                    class="custom-control-success"
                                    name="check-button"
                                    v-model="data.account.pt_attend_whatsapp"
                                    switch
                                >
                                    <span class="switch-icon-left">
                                    <feather-icon icon="CheckIcon" />
                                    </span>
                                    <span class="switch-icon-right">
                                    <feather-icon icon="XIcon" />
                                    </span>
                                </b-form-checkbox>
                            </div>
                        </b-form-group>
                    </b-col>
                    <b-col md="12" lg="6">
                        <b-form-group :label="$t('PT and Class Attend Message')" label-for="member_code">
                            <div>
                                <b-form-checkbox
                                    :checked="to_true_false(data.account.crontab_send_whatsapp)"
                                    class="custom-control-success"
                                    name="check-button"
                                    v-model="data.account.crontab_send_whatsapp"
                                    switch
                                >
                                    <span class="switch-icon-left">
                                    <feather-icon icon="CheckIcon" />
                                    </span>
                                    <span class="switch-icon-right">
                                    <feather-icon icon="XIcon" />
                                    </span>
                                </b-form-checkbox>
                            </div>
                        </b-form-group>
                    </b-col>
                    <b-col  md="12" lg="6">
                        <b-form-group :label="$t('Class Minimum Alert')" label-for="member_code">
                            <div>
                                <b-form-checkbox
                                    :checked="data.account.meet_min_alert"
                                    class="custom-control-success"
                                    name="check-button"
                                    v-model="data.account.meet_min_alert"
                                    switch
                                >
                                    <span class="switch-icon-left">
                                    <feather-icon icon="CheckIcon" />
                                    </span>
                                    <span class="switch-icon-right">
                                    <feather-icon icon="XIcon" />
                                    </span>
                                </b-form-checkbox>
                            </div>
                        </b-form-group>
                    </b-col>
                    <b-col  md="12" lg="6">
                        <b-form-group :label="$t('Pay Membership via Debit')" label-for="pay_by_debit">
                            <div>
                                <b-form-checkbox
                                    :checked="data.account.debit_pay_membership"
                                    class="custom-control-success"
                                    name="check-button"
                                    v-model="data.account.debit_pay_membership"
                                    switch
                                >
                                    <span class="switch-icon-left">
                                    <feather-icon icon="CheckIcon" />
                                    </span>
                                    <span class="switch-icon-right">
                                    <feather-icon icon="XIcon" />
                                    </span>
                                </b-form-checkbox>
                            </div>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row class="mt-2 mb-2">
                    <b-col>
                        <!-- <b-button :disabled="processing" variant="primary" class="mb-1 mb-sm-0 mr-0 mr-sm-1" :block="$store.getters['app/currentBreakPoint'] === 'xs'" @click="save" v-if="$can('read', 'admin')"> -->
                        <b-button :disabled="processing" variant="primary" class="mb-1 mb-sm-0 mr-0 mr-sm-1" :block="$store.getters['app/currentBreakPoint'] === 'xs'" @click="save"   v-if="permission_check(client_module.menu_permission,35)">
                            {{ $t('Save Changes') }}
                        </b-button>
                    </b-col>
                </b-row>
            </b-form>
        </b-col>
        <b-col lg="4">
            <img :src="data.account.logo" style="max-width:100%;" v-if="this.base64 == null">
            <img :src="base64" style="max-width:100%;" v-if="this.base64 != null">
        </b-col>
    </b-row>
</div>
</template>

<script>
import {
    BFormTextarea,
    BCardText,
    BAlert,
    BLink,
    BCard,
    BCardHeader,
    BFormFile,
    BCardBody,
    BMedia,
    BFormCheckbox,
    BAvatar,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BButton,
    BTab,
    BTabs,
    BListGroup,
    BListGroupItem,
    BBadge
} from 'bootstrap-vue'
import {
    ref
} from '@vue/composition-api'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import router from '@/router'
import moment from 'moment'


export default {
    components: {
        ToastificationContent,
        BFormTextarea,
        BFormCheckbox,
        BBadge,
        BCard,
        BCardText,
        vSelect,
        flatPickr,
        BFormFile,
        BCard,
        BCardHeader,
        BCardBody,
        BAvatar,
        BListGroup,
        BListGroupItem,
        BForm,
        BFormGroup,
        BMedia,
        BFormInput,
        BFormRadioGroup,
        BFormCheckboxGroup,
        BButton,
        BRow,
        BCol,
        BTab,
        BTabs,
        BCard,
        BAlert,
        BLink,
    },
    data() {
        return {
          client_module: JSON.parse(localStorage.getItem('userData')),
            base64 : null,
            processing : false
        }
    },

    computed: {
        invoiceTypeOptions() {
            return [
                { label: this.$t('PDF'), value: 'PDF' },
                { label: this.$t('PAPER'), value: 'PAPER' },
            ]
        },
        scheduleFirstDayOptions() {
            return [
                { label: `${this.$t('SUN')} ${this.$t('Sunday')}`, value: '0' },
                { label: `${this.$t('MON')} ${this.$t('Monday')}`, value: '1' },
                { label: `${this.$t('TUE')} ${this.$t('Tuesday')}`, value: '2' },
                { label: `${this.$t('WED')} ${this.$t('Wednesday')}`, value: '3' },
                { label: `${this.$t('THU')} ${this.$t('Thursday')}`, value: '4' },
                { label: `${this.$t('FRI')} ${this.$t('Friday')}`, value: '5' },
                { label: `${this.$t('SAT')} ${this.$t('Saturday')}`, value: '6' },
            ]
        },
        scheduleDisplayFieldOptions() {
            return [
                { label: this.$t('Member Code'), value: 'member_code' },
                { label: this.$t('Chinese Name'), value: 'zh_name' },
                { label: this.$t('English Name'), value: 'en_name' },
            ]
        },
        expire_display: function () {
            return moment(this.data.expire).format('DD MMMM ,YYYY')
        },
        user_limit: function () {
            if (this.data.account.user_limit < 1) {
                return this.$t('Unlimited');
            } else {
                return this.data.account.user_limit;
            }
        }
    },
    props: {
        data : {
        required: true,
        },
    },
    created() {
        console.log(this.account)
    },
    watch: {
        "data.account.new_logo" : function (newVal, oldVal) {

            let reader = new FileReader();
            reader.readAsDataURL(newVal);
            reader.onload = evt => {
                let img = new Image();
                img.onload = () => {
                    if (img.width != 400 || img.height != 132) {
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-center',
                            props: {
                            title: this.$t('Error'),
                            icon: 'XIcon',
                            variant: 'danger',
                            text: this.$t('Logo must be 400px width 132px height'),
                            },
                        })
                        this.data.account.new_logo = null
                        this.base64 = null
                    }
                this.imageLoaded = true;
                }
                img.src = evt.target.result;
            }
            if(newVal) {
                this.createBase64Image(newVal);
            } else {
                this.base64 = null;
            }
            }
    },
    methods: {
        createBase64Image: function(FileObject) {
            const reader = new FileReader();

            reader.onload = (event) => {
                this.base64 = event.target.result;
            }
            reader.readAsDataURL(FileObject);
        },
        save() {
        this.processing = true
        this.data.account.base64 = this.base64
      this.$http.post(process.env.VUE_APP_API_BASE+`/account/?page=basic`, this.data.account )
        .then(res => {
          if (res.data.result === true) {
               this.$toast({
                 component: ToastificationContent,
                 position: 'top-center',
                 props: {
                                     title: this.$t('Success'),
                   icon: 'CheckIcon',
                   variant: 'success',
                   text: res.data.message,
                 },
               })
               this.processing = false
             } else {
               this.$toast({
                 component: ToastificationContent,
                 position: 'top-center',
                 props: {
                                     title: this.$t('Error'),
                   icon: 'XIcon',
                   variant: 'danger',
                   text: res.data.message,
                 },
               })
               this.processing = false
             }
        })
        },
        to_true_false(value) {
            if (value == "Y" || value == "TRUE") {
                return true
            } else {
                return false
            }
        },
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
